<template>
	<div class="full" style="box-sizing: border-box;position: relative;">
		<div class="full flex" style="flex-direction: column;box-sizing: border-box;padding: 20px;">
			<div class="full" style="position: relative;box-shadow: 0px 0px 2px darkgray;">
				<tinymce v-if="editShow" class="full" ref="manualEdit" :images_upload_handler="images_upload_handler"
					:toolbar="toolbar" :menubar="true">
				</tinymce>
				<template v-else>
					<div v-if="content" class="full" v-html="content" style="overflow: auto;box-sizing: border-box;padding: 20px;"></div>
					<div v-else class="full flex"
						style="overflow: auto;flex-direction: column;align-items: center;justify-content: center;">暂无内容
					</div>
				</template>

			</div>
			<div class="flex" style="margin: 10px 0px;justify-content: flex-end;" v-if="editShow">
				<el-button @click="backedit">返回</el-button>
				<el-button type="primary" @click="save">保存</el-button>
			</div>
			<div class="flex" style="margin: 10px 0px;justify-content: flex-end;" v-if="!editShow">
				<el-button type="danger" @click="editcontent">编辑</el-button>
			</div>
		</div>
	</div>
</template>
<style scoped>

</style>
<script>
	import OSS from 'ali-oss'
	import tinymce from '@_system/components/tinymce.vue'
	export default {
		props: {
			data: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				editShow: false,
				content: null,
				// plugins: 'anchor preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help autosave autoresize',
				toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent |  styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs',
				images_upload_handler: this.imagesUploadHandler
			}

		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.get()
			},
			imagesUploadHandler(blobInfo, success) {
				let file = new File([blobInfo.blob()], 'image.png', {
					type: 'image/png'
				})
				this.uploadOss(file, 'manual').then((res) => {
					success(res.url)
				})
			},
			uploadOss(file, moduleName) {
				return new Promise((reslove, reject) => {
					let client = new OSS(window.config.oss);
					let name = moduleName + '/' + Date.now() + '_' + (Math.random() * 100000).toFixed(0) + file
						.name
					client.put(name, file).then((res) => {
						reslove(res)
					}).catch((e) => {
						reject(e)
					})
				})
			},
			editcontent() {
				this.editShow = true
				this.$nextTick(() => {
					this.$refs.manualEdit.myValue = this.content
				})
			},
			backedit() {
				this.editShow = false

			},
			get() {
				this.$api.manual.get(this.data.meta.id).then((res) => {
					console.log(res)
					if (this.editShow) {
						this.$refs.manualEdit.myValue = res?res.content:null
					} else {
						this.content = res?res.content:null
					}

				})
			},
			save() {
				this.$api.manual.save({
					moduleid: this.data.meta.id,
					module: this.data.controller,
					content: this.$refs.manualEdit.myValue
				}).then(() => {
					this.content = this.$refs.manualEdit.myValue
					this.$message.success('操作成功')
				})
			}
		},
		components: {
			tinymce
		}
	}
</script>